export const MIN_ZOOM = 0
export const MAX_ZOOM = 3
export const STEP_ZOOM = 0.01
